<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay>
        <v-card >
            <div class="pa-3">
                <v-img src="https://www.dikitoon.com/img/DikitoonBetaSvgLogo.cbb7fd28.svg" max-width="160"></v-img>
                <h2>{{shopName}}は、現在メンテナンス中です。</h2>
                <h3>再開予定日時: {{resumeOnStr}}</h3>
                <p>上記は閲覧の再開予定です。注文受付等の予定ではありません。</p>
                <p>しばらくお待ちください。</p>
                <p>上記時刻になったら、再読込してください。</p>
            </div>

        </v-card>
    </v-dialog>
</template>

<script>
//import { AmplifyEventBus } from 'aws-amplify-vue'
import moment from 'moment-timezone'
import { Logger } from 'aws-amplify';
const logger = new Logger('SuspendedFullComponent','INFO');

export default {
    data() {
        return {
            dialog: true
        }
    },
    async mounted(){
        logger.info("SuspendedFullComponent",this.resumeOnStr)
    },
    computed:{
        shopName:function(){
            return this.$store.state.shopName
        },
        resumeOnStr:function(){
            let res = ""
            const suspendUntil = this.$store.state.suspendUntil
            if(suspendUntil.time){
                const targetTime = moment(suspendUntil.time)
                if(targetTime.isAfter(moment())){
                    res += targetTime.tz("Asia/Tokyo").format("Y-MM-DD A hh:mm")
                }
            }
            return res

        }
    }
}
</script>